// extracted by mini-css-extract-plugin
export default {"status":"SequenceStatus_status__r5dPC"};